export enum ResourceNavigationType {
  JOBS,
  VEHICLES,
  DRIVERS,
  ASSISTANTS,
  TRAILERS
}
